import React from "react";
import Dropzone from "react-dropzone";
import "./Dropzone.scss";

interface CustomDropzoneProps {
  files: File[];
  onDrop: (acceptedFiles: File[]) => void;
  onRemove: (index: number) => void;
  multiple?: boolean;
  placeholder?: string;
}

const CustomDropzone: React.FC<CustomDropzoneProps> = ({
  files,
  onDrop,
  onRemove,
  multiple = true,
  placeholder = "Drag & drop files here or click to select",
}) => {
  return (
    <Dropzone onDrop={onDrop} multiple={multiple}>
      {({ getRootProps, getInputProps }) => (
        <div className="custom-dropzone" {...getRootProps()}>
          <input {...getInputProps()} />
          {files.length === 0 ? (
            <p className="dropzone-placeholder">{placeholder}</p>
          ) : (
            <div className="file-preview-grid">
              {files.map((file, idx) => (
                <div key={idx} className="file-card">
                  <a className="contracting-docs-modal__doc-title">{file.name}</a>
                  <button
                    type="button"
                    className="file-card__remove-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      onRemove(idx);
                    }}>
                    {/* <Icon name={IconName.Close} size="18px" /> */}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </Dropzone>
  );
};

export default CustomDropzone;
